export default __webpack_public_path__ + "static/media/timetable.5d0b3d94.webp";